<template>
  <div class="project-template" v-loading="loading">
    <div class="title">项目模板</div>
    <div>
      <div class="right">
        <div class="mRight10">
          <el-input
            v-model="searchText"
            size="small"
            placeholder="项目模板名称"
            clearable
            prefix-icon="el-icon-search"
            @input="search"
          ></el-input>
        </div>
        <base-button type="primary" @click="openDialog">
          新建
        </base-button>
      </div>
    </div>
    <div class="table-wrapper">
      <el-table
        ref="templatesTable"
        :data="filterData"
        tooltip-effect="dark"
        height="100%"
        v-ps="'.el-table__body-wrapper'"
      >
        <el-table-column
          v-for="templateColumn in projectTemplateColumns"
          :key="templateColumn.value"
          :prop="templateColumn.value"
          :label="templateColumn.label"
          :width="templateColumn.width"
        >
          <template slot-scope="scope">
            <template v-if="templateColumn.value === 'name'">
              <div class="template-item">
                <div class="template-icon">
                  <!--                  <svg-icon icon-class="sheet-detail"></svg-icon>-->
                  <svg-icon
                    :icon-class="scope.row.icon ? 'project_' + scope.row.icon : 'project_folder'"
                  ></svg-icon>
                </div>
                <div class="font-main template-name" v-tip="2">
                  {{ scope.row[templateColumn.value] }}
                </div>
              </div>
            </template>
            <template v-else>
              <div>{{ _.get(scope.row, templateColumn.value) }}</div>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template v-slot="scope">
            <el-button @click.stop="toAdmin(scope.row)" type="text">
              编辑
            </el-button>
            <el-button @click.stop="deleteTemplate(scope.row)" type="text">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <create-dialog :visible.sync="dialogVisible"></create-dialog>
  </div>
</template>

<script>
import BaseButton from "@/components/UIComponents/Button"
import CreateDialog from "./CreateDialog"
import { getProjectTemplates, deleteProjectTemplate } from "@/api/project/project"
import { loadingService } from "@/utils/ui"
import { projectTemplateColumns } from "@/views/Company/Manage/Project/static"
import { stringIncludes } from "@/utils/common"

export default {
  name: "project-template",
  components: { BaseButton, CreateDialog },
  data() {
    return {
      projectTemplateColumns,
      loading: false,
      dialogVisible: false,
      templates: [],
      searchText: "",
      filterData: []
    }
  },
  created() {
    this.getTemplates()
  },
  methods: {
    getTemplates() {
      this.loading = true
      getProjectTemplates("MANAGE").then(res => {
        this.templates = res
        this.filterData = this.templates
        this.loading = false
      })
    },
    openDialog() {
      this.dialogVisible = true
    },
    toAdmin(template) {
      this.$router.push({
        name: "project-task-list",
        params: { projectId: template.id },
        query: { template: true }
      })
    },
    deleteTemplate(template) {
      this.$confirm("确认删除该项目模板？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const loadingInstance = loadingService()
          deleteProjectTemplate(template.id)
            .then(res => {
              this.$message.success("操作成功！")
              this.getTemplates()
            })
            .finally(() => loadingInstance.close())
        })
        .catch(() => {
          return
        })
    },
    search() {
      this.filterData = this.templates.filter(i => stringIncludes(i.name, this.searchText))
    }
  }
}
</script>

<style lang="scss" scoped>
.project-template {
  display: flex;
  flex-flow: column;
  overflow: hidden;
  height: calc(100vh - 52px);
  margin: -15px 0;
  .title {
    font-size: $font-size-title-first;
    padding: 15px 20px 10px 20px;
    border-bottom: 1px solid #e4e4e4;
  }
  .right {
    display: flex;
    float: right;
    margin: 20px 20px 0 20px;
    ::v-deep {
      .el-input-group__append {
        padding: 0 10px;
      }
    }
  }
  .table-wrapper {
    flex: 1;
    overflow: hidden;
    padding: 0 0 0 30px;
    box-sizing: border-box;
    .el-table {
      .template-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 73px;
        &:not(:last-child) {
          border-bottom: 1px solid #e4e4e4;
        }
        .template-icon {
          @include flex-center;
          flex-shrink: 0;
          box-sizing: border-box;
          width: 48px;
          height: 48px;
          background: #1989fa;
          border-radius: 12px;
          margin-right: 24px;
          font-size: 28px;
          color: #fff;
        }
        .template-name {
          flex: auto;
        }
      }
    }
  }
}
</style>
